export interface ElectronConfig {
  serverUrl: string;
  selectedPrinterId?: number;
}

export type ElectronPlatform =
  | "aix"
  | "darwin"
  | "freebsd"
  | "linux"
  | "openbsd"
  | "sunos"
  | "win32";

export interface ElectronAPI {
  isElectron: true;
  platform: ElectronPlatform;
  getConfig: () => Promise<ElectronConfig | null>;
  setConfig: (config: ElectronConfig) => Promise<void>;
  setSelectedPrinterId: (selectedPrinterId: number | null) => Promise<void>;
  printZpl: (
    zpl: string,
    printer: {
      type: "NETWORK" | "USB";
      address?: string;
      port?: number;
      usbVendorId?: string;
      usbProductId?: string;
    },
  ) => Promise<{ success: boolean; error?: string }>;
  listUsbPrinters: () => Promise<
    Array<{ vendorId: string; productId: string; name: string }>
  >;
  testPrint: (printer: {
    type: "NETWORK" | "USB";
    address?: string;
    port?: number;
    usbVendorId?: string;
    usbProductId?: string;
  }) => Promise<{ success: boolean; error?: string }>;
  onUpdateAvailable: (callback: (version: string) => void) => () => void;
  onUpdateDownloaded: (callback: (version: string) => void) => () => void;
}

declare global {
  interface Window {
    electronAPI?: ElectronAPI;
  }
}

export function isElectron(): boolean {
  return !!window.electronAPI?.isElectron;
}

export function hasElectronTitlebar(): boolean {
  return window.electronAPI?.platform === "darwin";
}

export function getElectronAPI(): ElectronAPI | null {
  return window.electronAPI ?? null;
}
